'use client'

import Link from 'next/link';
import { Linkedin, Instagram, Twitter } from 'lucide-react';
import { useCookieConsent } from '@/components/cookies/cookie-consent-context';

export default function Footer() {
    const { openSettings } = useCookieConsent();

    return (
        <footer className="bg-slate-50 border-t border-slate-200 pt-16 pb-8">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">

                    {/* Colonna 1: Brand & Bio SEO */}
                    <div className="col-span-1 md:col-span-1">
                        <Link href="/" className="text-xl font-bold text-slate-900 mb-4 block">
                            KennyDB CRM
                        </Link>
                        <p className="text-mocha-900 text-sm leading-relaxed">
  Il primo garante digitale per agenti plurimandatari. Recupera il controllo totale sulle tue provvigioni, elimina gli errori dei brand e trasforma i dati dei tuoi clienti nel tuo asset più prezioso.
</p>
                    </div>

                    {/* Colonna 2: Risorse (SEO Interno) */}
                    <div>
                        <h3 className="font-semibold text-slate-900 mb-4 uppercase tracking-wider text-xs">Risorse</h3>
                        <ul className="space-y-3 text-sm">
                            <li>
                                <Link href="/blog" className="text-slate-600 hover:text-indigo-600 transition-colors">Blog & News</Link>
                            </li>
                            <li>
                                <Link href="/blog/crm-agenti-moda-italia-2025" className="text-slate-600 hover:text-indigo-600 transition-colors">Articoli e Guide</Link>
                            </li>
                            <li>
                                <Link href="/blog/fine-cataloghi-stampati-agenti-fashion-digitale-2025" className="text-slate-600 hover:text-indigo-600 transition-colors">Casi di Successo</Link>
                            </li>
                        </ul>
                    </div>

                    {/* Colonna 3: Azienda */}
                    <div>
                        <h3 className="font-semibold text-slate-900 mb-4 uppercase tracking-wider text-xs">Azienda</h3>
                        <ul className="space-y-3 text-sm">
                            <li>
                                <Link href="/contacts" className="text-slate-600 hover:text-indigo-600 transition-colors">Contattaci</Link>
                            </li>
                            <li>
                                <Link href="/about" className="text-slate-600 hover:text-indigo-600 transition-colors">Chi Siamo</Link>
                            </li>
                            <li>
                                <Link href="/sitemap.xml" className="text-slate-600 hover:text-indigo-600 transition-colors">Sitemap</Link>
                            </li>
                        </ul>
                    </div>

                    {/* Colonna 4: Social & Community */}
                    <div>
                        <h3 className="font-semibold text-slate-900 mb-4 uppercase tracking-wider text-xs">Seguici</h3>
                        <div className="flex gap-4">
                            <a href="https://linkedin.com/company/kennydbcrm" target="_blank" rel="noopener noreferrer" className="p-2 bg-white border border-slate-200 rounded-lg text-slate-600 hover:text-indigo-600 hover:border-indigo-200 transition-all">
                                <Linkedin size={20} />
                                <span className="sr-only">LinkedIn</span>
                            </a>
                            <a href="https://instagram.com/kennydbcrm" target="_blank" rel="noopener noreferrer" className="p-2 bg-white border border-slate-200 rounded-lg text-slate-600 hover:text-indigo-600 hover:border-indigo-200 transition-all">
                                <Instagram size={20} />
                                <span className="sr-only">Instagram</span>
                            </a>
                            <a href="https://twitter.com/kennydbcrm" target="_blank" rel="noopener noreferrer" className="p-2 bg-white border border-slate-200 rounded-lg text-slate-600 hover:text-indigo-600 hover:border-indigo-200 transition-all">
                                <Twitter size={20} />
                                <span className="sr-only">Twitter</span>
                            </a>
                        </div>
                    </div>
                </div>

                {/* Bottom Bar: Legal */}
                <div className="border-t border-slate-200 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
                    <div className="flex gap-6 text-xs text-slate-500">
                        <Link href="/privacy" className="hover:text-slate-900 transition-colors">Privacy Policy</Link>
                        <Link href="/terms" className="hover:text-slate-900 transition-colors">Termini di Servizio</Link>
                        <button
                            onClick={openSettings}
                            className="hover:text-slate-900 transition-colors cursor-pointer"
                        >
                            Cookie
                        </button>
                        <span>P.IVA 03793180831</span>
                    </div>
                    <p className="text-slate-400 text-xs">
                        &copy; {new Date().getFullYear()} KennyDB CRM. Sviluppato in Italia 🇮🇹
                    </p>
                </div>
            </div>
        </footer>
    );
}